/* Aussie Magnets - product page designer / data sheet buttons */
    (function () {
      var box = document.querySelector('[data-am-dz]');
      if (!box || box._amInit) return;
      box._amInit = true;

      function track(ev) {
        try { (window.dataLayer = window.dataLayer || []).push({ event: ev, am_product: box.getAttribute('data-title') || '' }); } catch (e) {}
      }

      // Move the buttons into the empty space beside Pull Strength / Grade / Coating / Item
      try {
        var meta = box.closest('.product-meta');
        if (meta) {
          var first = null, kids = [].slice.call(meta.children);
          for (var i = 0; i < kids.length; i++) {
            if (/Pull Strength:/.test(kids[i].textContent) && kids[i].tagName === 'P') { first = kids[i]; break; }
          }
          if (first) {
            var row = document.createElement('div'); row.className = 'am-meta-row';
            var left = document.createElement('div'); left.className = 'am-meta-left';
            meta.insertBefore(row, first);
            var n = first;
            while (n && n !== box) {
              var nx = n.nextSibling;
              if (n.nodeType === 1 && /reviews-badge|share-buttons/.test(n.className || '')) break;
              left.appendChild(n);
              n = nx;
            }
            row.appendChild(left);
            row.appendChild(box);
            var ref = meta.querySelector('.product-meta__reference');
            if (ref && !left.contains(ref)) left.appendChild(ref);
          }
        }
      } catch (e) {}

      box.querySelector('[data-am-dz-view]').addEventListener('click', function () { track('am_product_designer'); });

      var pdfBtn = box.querySelector('[data-am-dz-pdf]');
      var label = pdfBtn.querySelector('span');
      var busy = false, hostReady = null;
      var qs = '?' + (pdfBtn.getAttribute('data-src').split('?')[1] || '');

      // Scope the designer's CSS to the hidden host so it can't touch the product page
      function scopeCss(text) {
        var out = '';
        try {
          var sh = new CSSStyleSheet(); sh.replaceSync(text);
          var walk = function (rules) {
            var o = '';
            for (var i = 0; i < rules.length; i++) {
              var r = rules[i];
              if (r.selectorText !== undefined && r.style) {
                var sels = r.selectorText.split(',').map(function (x) { return x.trim(); }).filter(function (x) {
                  return !/^(html|body|main|:root|\.shopify-section|\.main-content|\*)(\s|$|[:.\[>])/.test(x) || /^\.shopify-section-/.test(x);
                }).map(function (x) { return '#am-pdf-host ' + x; });
                if (sels.length) o += sels.join(',') + '{' + r.style.cssText + '}';
              } else if (r.media && r.cssRules) {
                // The hidden designer is always laid out as a 1280px desktop page, even on a phone:
                // apply width rules as if the screen were 1280px wide, keep any other media rules as-is.
                var mt = r.media.mediaText, keep = true, other = false;
                mt.split(/\s+and\s+/i).forEach(function (part) {
                  var mx = part.match(/max-width\s*:\s*([\d.]+)px/i), mn = part.match(/min-width\s*:\s*([\d.]+)px/i);
                  if (mx) { if (1280 > +mx[1]) keep = false; }
                  else if (mn) { if (1280 < +mn[1]) keep = false; }
                  else if (/\(/.test(part)) other = true;
                });
                if (!/width/i.test(mt)) o += '@media ' + mt + '{' + walk(r.cssRules) + '}';
                else if (keep) o += other ? ('@media ' + mt.replace(/\(\s*(max|min)-width\s*:[^)]*\)\s*(and\s*)?/gi, '').replace(/\s*and\s*$/i, '') + '{' + walk(r.cssRules) + '}') : walk(r.cssRules);
              } else if (r.type === 7) { o += r.cssText; }
            }
            return o;
          };
          out = walk(sh.cssRules);
        } catch (e) {}
        return out;
      }

      function loadScript(src, inline) {
        return new Promise(function (res, rej) {
          var s = document.createElement('script');
          if (src) { s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); }
          else { s.textContent = inline; document.head.appendChild(s); res(); }
        });
      }

      function buildHost() {
        if (hostReady) return hostReady;
        hostReady = fetch('/pages/magnet-calculator', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.getElementById('shopify-section-magnet-calculator') || (doc.querySelector('.app-wrap') || {}).parentNode;
          if (!sec) throw new Error('no designer');
          var host = document.createElement('div');
          host.id = 'am-pdf-host'; host.setAttribute('aria-hidden', 'true');
          host.style.cssText = 'position:fixed;left:-4000px;top:0;width:1280px;height:1100px;overflow:hidden;pointer-events:none;z-index:-1';
          var scripts = [].slice.call(sec.querySelectorAll('script'));
          var cssJobs = [];
          [].slice.call(sec.querySelectorAll('style')).forEach(function (st) { cssJobs.push(Promise.resolve(st.textContent)); st.remove(); });
          [].slice.call(sec.querySelectorAll('link[rel=stylesheet]')).forEach(function (l) { cssJobs.push(fetch(l.href).then(function (r) { return r.text(); }).catch(function () { return ''; })); l.remove(); });
          scripts.forEach(function (s) { s.remove(); });
          host.innerHTML = sec.innerHTML;
          document.body.appendChild(host);
          return Promise.all(cssJobs).then(function (css) {
            var st = document.createElement('style'); st.textContent = css.map(scopeCss).join('\n'); document.head.appendChild(st);
            window._amEmbed = true; window._amPrefillQS = qs;
            // capture load / DOMContentLoaded listeners the designer registers, then run them ourselves
            var caught = [], origAdd = window.addEventListener, origDocAdd = document.addEventListener;
            window.addEventListener = function (t, fn, o) { if (t === 'load') { caught.push(fn); return; } return origAdd.call(window, t, fn, o); };
            document.addEventListener = function (t, fn, o) { if (t === 'DOMContentLoaded') { caught.push(fn); return; } return origDocAdd.call(document, t, fn, o); };
            var seen = {}, chain = Promise.resolve();
            scripts.forEach(function (s) {
              chain = chain.then(function () {
                if (s.src) {
                  var key = s.src.split('?')[0];
                  if (seen[key]) return; seen[key] = 1;
                  if (/three\.min\.js$/.test(key) && window.THREE) return;
                  if (/jspdf/.test(key) && window.jspdf) return;
                  return loadScript(s.src);
                }
                return loadScript(null, s.textContent);
              });
            });
            return chain.then(function () {
              window.addEventListener = origAdd; document.addEventListener = origDocAdd;
              caught.forEach(function (fn) { try { fn.call(window, new Event('load')); } catch (e) {} });
              try { var R = window.renderer; if (R && !R._amP) { var o = R.render.bind(R); R.render = function (a, b) { if (!window._amHostPause) o(a, b); }; R._amP = 1; } } catch (e) {}
            }, function (err) { window.addEventListener = origAdd; document.addEventListener = origDocAdd; throw err; });
          });
        });
        hostReady.catch(function () { hostReady = null; });
        return hostReady;
      }

      pdfBtn.addEventListener('click', function () {
        if (busy) return;
        busy = true; track('am_product_pdf'); window._amHostPause = false;
        pdfBtn.disabled = true; label.textContent = 'Preparing PDF…';
        var done = false, first = !window._amPrefillGo;
        function finish(msg) {
          if (done) return; done = true; clearTimeout(to);
          window._amPdfCb = null; window._amPdfFail = null; window._amHostPause = true;
          label.textContent = msg; pdfBtn.disabled = false; busy = false;
          setTimeout(function () { label.textContent = 'Download PDF Data Sheet'; }, 3500);
        }
        function failed() {
          finish('Download PDF Data Sheet');
          var v = pdfBtn.getAttribute('data-view');
          var note = box.querySelector('.am-dz-note');
          if (!note) { note = document.createElement('div'); note.className = 'am-dz-note'; box.appendChild(note); }
          note.innerHTML = 'Couldn’t prepare the PDF here — <a href="' + v + '" target="_blank" rel="noopener">open it in the Magnet Designer</a>.';
        }
        var to = setTimeout(failed, 45000);
        window._amPdfCb = function (doc, name) { try { doc.save(name || 'Magnet-Data-Sheet.pdf'); finish('Downloaded ✓'); } catch (e) { failed(); } };
        window._amPdfFail = failed;
        buildHost().then(function () {
          if (!first && window._amPrefillGo) window._amPrefillGo(qs);
        }).catch(failed);
      });
    })();
